import axios from 'axios'

// Get business fees
const get = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/business-bordero`)
  return data
}

// Update business fees
const update = async (fees) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/business-bordero`, {
    fees
  })
  return data
}

export {
  get,
  update
}
